import { Theme } from '@mui/material'
import { makeStyles } from 'tss-react/mui'

import { themeColors } from '../../theme'

const breakpoints = {
  mobile: '@media (max-width: 767px)',
  tablet: '@media (max-width: 1650px)',
}

export const useStyles = makeStyles()((theme: Theme) => ({
  patientChartContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  TopSectionView: {
    padding: '20px 10px',
    borderRadius: '10px',
    boxShadow: '1px 3px 4px palette.boxShadow',
    margin: '10px 0',
  },
  TabView: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px',
    padding: '0 10px',
  },
  EachTabView: {
    borderBottomColor: themeColors.blue40,
    borderBottomWidth: '4px',
    cursor: 'pointer',
  },
  EachTabSelectedView: {
    borderBottomColor: themeColors.blue40,
    borderBottomWidth: '4px',
    cursor: 'pointer',
  },
  TabTxt: {
    fontSize: '16px',
    lineHeight: '20px',
    textAlign: 'center',
    marginBottom: '2px',
  },

  patientChartInfoContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    border: 'solid 2px lightgrey',
    borderRadius: '5px',
    padding: '20px 10px',
    backgroundColor: themeColors.white,
    boxShadow: '0px 5px 10px -4px rgba(0, 0, 0, 0.25)',
    minWidth: '600px',
    overflow: 'scroll',
    marginBottom: '30px',
  },

  patientChartInfoCol: {
    marginRight: '20px',
  },

  patientData: {
    border: 'solid 2px lightgrey',
    borderRadius: '3px',
  },

  patientChartDataContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    width: '100%',
    gap: '20px',

    [breakpoints.tablet]: {
      flexDirection: 'column',
      padding: '0 10px',
    },

    [breakpoints.mobile]: {
      flexDirection: 'column',
      padding: '0 10px',
    },
  },

  // graph and table
  patientChartDataLeft: {
    display: 'flex',
    flexDirection: 'column',
    width: 'calc(50% - 10px)', // 50% width minus half of the gap
    backgroundColor: themeColors.white,
    borderRadius: '5px',
    border: 'solid 2px lightgrey',
    padding: '10px',
    boxShadow: '0px 5px 10px -4px rgba(0, 0, 0, 0.25)',

    [breakpoints.tablet]: {
      width: '100%',
      padding: '15px',
    },

    [breakpoints.mobile]: {
      width: '100%',
      padding: '10px',
    },
  },

  //bac / drink types / mum table
  patientChartDataRight: {
    display: 'flex',
    flexDirection: 'column',
    width: 'calc(50% - 10px)', // 50% width minus half of the gap
    backgroundColor: themeColors.white,
    borderRadius: '5px',
    border: 'solid 2px lightgrey',
    padding: '10px',
    boxShadow: '0px 5px 10px -4px rgba(0, 0, 0, 0.25)',

    [breakpoints.tablet]: {
      width: '100%',
      padding: '15px',
    },

    [breakpoints.mobile]: {
      width: '100%',
      padding: '10px',
    },
  },

  patientGraphContainer: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: themeColors.white,
    minWidth: '600px',
    overflow: 'scroll',
  },

  graphTabs: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    margin: '0.5rem 0',
    borderBottom: '1px solid',
    borderBottomColor: themeColors.gray90,
    padding: '10px 0',
    width: '100%',
  },

  reviewGraphTabs: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    gap: '16px 5px',
    margin: '0.5rem 0',
    borderBottom: '1px solid',
    borderBottomColor: themeColors.gray90,
    padding: '10px 0',
    width: '100%',
  },

  graphTabButton: {
    border: 'none',
    backgroundColor: 'transparent',
    margin: '0 10px',
    padding: '5px 10px',
    width: 170,
    cursor: 'pointer',
    '&:hover': {
      background: themeColors.darkBlue,
      color: themeColors.grayWhite,
      borderRadius: 5,
    },
  },

  graphTabButtonTxt: {
    fontWeight: 700,
    fontSize: '18px',
    fontFamily: theme.typography.fontFamily,
  },

  graphTabButtonSelected: {
    border: 'none',
    margin: '0 20px',
    padding: '5px 10px',
    background: themeColors.darkBlue,
    color: themeColors.grayWhite,
    borderRadius: 5,
  },

  bacChartViewBtns: {
    width: 'max-content',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifySelf: 'flex-end',
  },

  bacChartViewBtn: {
    border: 'none',
    backgroundColor: 'transparent',
    marginLeft: '20px',
    padding: '5px 10px',
    cursor: 'pointer',
    '&:hover': {
      background: themeColors.grayWhite,
      borderRadius: 5,
    },
    fontFamily: 'lato',
  },

  bacChartViewBtnSelected: {
    width: 'max-content',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifySelf: 'flex-end',
    backgroundColor: '#e0f0fe',
    borderRadius: '5px',
  },

  chart: {
    margin: '10px 0',
  },

  // chart styles
  timeRangeTabs: {
    marginBottom: '20px',
    width: '100%',
  },

  timeRangeTabBtn: {
    border: 'none',
    backgroundColor: 'transparent',
    margin: '0 40px',
    padding: '5px 10px',
    cursor: 'pointer',
    '&:hover': {
      background: themeColors.grayWhite,
      color: themeColors.darkBlue,
    },
  },

  timeRangeTabBtnTxt: {
    fontWeight: 700,
    fontSize: '16px',
    fontFamily: theme.typography.fontFamily,
  },

  timeRangeTabBtnSelected: {
    border: 'none',
    margin: '0 40px',
    padding: '5px 10px',
    background: themeColors.grayWhite,
    color: themeColors.darkBlue,
  },

  // list styles
  recordListWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    flexWrap: 'wrap',
    margin: '5px 0 20px 0',
    minWidth: '600px',
    overflow: 'scroll',
  },

  recordItem: {
    margin: 10,
    width: 'max-content',
    display: 'flex',
    justifyContent: 'space-between',
    fontFamily: theme.typography.fontFamily,
  },

  recordItemTime: {
    fontSize: '16px',
    fontFamily: theme.typography.fontFamily,
    marginRight: 10,
  },

  recordItemResult: {
    fontWeight: 700,
    fontSize: '16px',
    fontFamily: theme.typography.fontFamily,
  },

  reviewTable: {
    borderCollapse: 'collapse',
    borderColor: themeColors.gray90,
    fontFamily: theme.typography.fontFamily,
    fontSize: 16,
    letterSpacing: '1px',
    width: '100%',
    padding: '10px',

    [breakpoints.mobile]: {
      fontSize: 12,
      letterSpacing: '0.5px',

      '& tbody': {
        gridTemplateColumns: '1fr', // Single column on mobile
      },

      '& th': {
        padding: '6px 0',
      },
    },
  },

  tableCaption: {
    margin: '15px 0',
    fontSize: '18px',
  },

  tableThead: {
    backgroundColor: themeColors.gray90,
    marginTop: 10,
    width: '100%',
  },

  tableLabelTh: {
    border: 'solid 2px',
    borderColor: themeColors.gray90,
    textAlign: 'left',
    padding: '0 5px',
  },

  videoLinkBtn: {
    fontSize: '16px',
    color: themeColors.blue,
    padding: '0',
    letterSpacing: '1px',
    textAlign: 'center',
    alignSelf: 'center',
    border: 'none',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    width: '100px',
  },

  tableSortBtn: {
    border: 'none',
    borderRadius: '5px',
    backgroundColor: 'transparent',
    padding: '10px 0',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    cursor: 'pointer',
    width: '100%',
    '&:hover': {
      backgroundColor: themeColors.grayWhite,
    },
  },

  tableSortTxt: {
    margin: '0 10px',
  },

  tableTh: {
    border: 'solid 2px',
    borderColor: themeColors.gray90,
    textAlign: 'left',
    padding: '10px 12px',
  },

  playerWrapper: {
    padding: '15px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',

    [breakpoints.tablet]: {
      marginTop: '15px',
      padding: '10px 0',
    },
  },

  reviewBtn: {
    fontSize: '16px',
    color: themeColors.blue,
    padding: '0',
    letterSpacing: '1px',
    textAlign: 'center',
    alignSelf: 'center',
    border: 'none',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: themeColors.grayWhite,
    },
  },

  modalBtnWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  fileAssignment: {
    margin: '5.25px 5px',
  },
}))
